export enum Msg {
  Success = 'İşleminiz başarıyla tamamlandı',
  Error = 'İşlem sırasında hata oluştu',
  DeviceDelete = 'Cihazı silmek istediğinize emin misiniz?',
  DeviceReset = 'Cihazı resetlemek istediğinize emin misiniz?',
  DeviceStop = 'Cihazı durdurmak istediğinize emin misiniz?',
  DeviceSettingSave = 'Ayarlar seçili cihazlara uygulanacak onaylıyor musunuz?',
  MessageSendSuccess = 'Mesajınız başarıyla gönderildi.',
  MessageTemplatedelete = 'Mesaj taslağını silmek istediğinize emin misiniz?',
}
